module.exports = __webpack_public_path__ + "static/media/PW.34964498.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PW.svg
// module id = 344
// module chunks = 0